import i18next from 'i18next';

i18next.addResources('es', 'projectsSearchModule', {
  search: 'Buscar',
  filter: 'Filtrar',
  filterBy: 'Filtrar por',
  apply: 'Aplicar',
  searchPlaceholder: 'Encuentra proyectos...'
});

i18next.addResources('en', 'projectsSearchModule', {
  search: 'Search',
  filter: 'Filter',
  filterBy: 'Filter by',
  apply: 'Apply',
  searchPlaceholder: 'Find projects...'
});

i18next.addResources('pt', 'projectsSearchModule', {
  search: 'Buscar',
  filter: 'Filtrar',
  filterBy: 'Filtrar por',
  apply: 'Aplicar',
  searchPlaceholder: 'Encontrar projetos...'
});
